import _styled2 from "styled-components";
import _styled from "styled-components";
import React from "react";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb.component.js";
import Icon from "../../atoms/icon/icon.component.js";
import {BreadcrumbsHeaderContainer} from "./breadcrumbs-header.styles.js";
function BreadcrumbsHeader({
  breadcrumbs
}) {
  return /* @__PURE__ */ React.createElement(BreadcrumbsHeaderContainer, null, /* @__PURE__ */ React.createElement(_StyledIcon, {
    name: "home"
  }), /* @__PURE__ */ React.createElement(_StyledBreadcrumb, {
    steps: breadcrumbs
  }));
}
export default BreadcrumbsHeader;
var _StyledIcon = _styled(Icon).withConfig({
  displayName: "breadcrumbs-headercomponent___StyledIcon",
  componentId: "sc-1r2ic9y-0"
})({
  marginRight: "1rem"
});
var _StyledBreadcrumb = _styled(Breadcrumb).withConfig({
  displayName: "breadcrumbs-headercomponent___StyledBreadcrumb",
  componentId: "sc-1r2ic9y-1"
})({
  display: "flex",
  alignSelf: "center",
  paddingTop: "0.25rem"
});
